import {
  UPDATE_APPOINTMENTS,
  UPDATE_APPOINTMENTS_FAILURE,
  UPDATE_APPOINTMENTS_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const updateAppointmentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_APPOINTMENTS:
      return { ...state, loading: true };
    case UPDATE_APPOINTMENTS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case UPDATE_APPOINTMENTS_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default updateAppointmentsReducer;
